import React from "react"
import inputTypeData from "../../config/inputTypes"
import autocompleteData, {
  categories as autocompleteCategories,
} from "../../config/autocomplete"
import inputmodeData from "../../config/inputModes"
import styles from "./index.module.scss"
import Caret from "./Caret.svg"
import InfoIcon from "./Info.svg"
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from "@reach/accordion"
import "@reach/accordion/styles.css"

import sharedStyles from "../../shared.module.scss"

const RadioButton = ({ children, name, onChange, value }) => {
  return (
    <label className={`${styles.tableItem} ${styles.autocompleteLabel}`}>
      <input
        type="radio"
        name={name}
        className={sharedStyles.visuallyHidden}
        onChange={onChange}
        value={value}
      />
      {children}
    </label>
  )
}

const ChoiceList = ({
  docLink,
  data,
  stateKey,
  stateValue,
  setConfig,
  categories,
}) => {
  const [filterState, setFilterState] = React.useState(false)
  return (
    <div className={styles.choiceList}>
      <div className={styles.docs}>
        <a href={docLink}>
          <InfoIcon />
          &nbsp; Read the docs
        </a>
      </div>
      {categories && (
        <div className={styles.categories}>
          <div>Filter options by category:</div>
          <ul className={styles.tagList}>
            {categories.sort().map(category => {
              return (
                <li>
                  <button
                    className={`${styles.tag} ${
                      category === filterState ? styles.tagSelected : ""
                    }`}
                    onClick={() => {
                      if (filterState === category) setFilterState(null)
                      else setFilterState(category)
                    }}
                  >
                    {category}
                  </button>
                </li>
              )
            })}
          </ul>
        </div>
      )}
      <form>
        {Object.keys(data)
          .filter(d => {
            if (!filterState) return true
            if (!data[d].category) return false
            return data[d].category.includes(filterState)
          })
          .map(key => {
            const isSelected = stateValue === key
            return (
              <div
                className={`${styles.row} ${
                  isSelected ? styles.isSelected : ""
                }`}
              >
                <RadioButton
                  name="type"
                  value={key}
                  onChange={e => {
                    if (e.target.checked)
                      setConfig({
                        [stateKey]: e.target.value,
                      })
                  }}
                >
                  <div className={styles.tableItemHeader}>{key}</div>
                </RadioButton>
                {isSelected && (
                  <button
                    aria-label="remove"
                    onClick={e => {
                      setConfig({
                        [stateKey]: null,
                      })
                    }}
                  >
                    × remove
                  </button>
                )}
              </div>
            )
          })}
      </form>
    </div>
  )
}

const PropSelector = ({
  setConfig,
  type,
  inputmode,
  autocomplete,
  accordionOpenIndex,
  updateAccordion,
}) => {
  return (
    <Accordion index={accordionOpenIndex} onChange={updateAccordion} multiple>
      <AccordionItem>
        <AccordionButton className={styles.accordionButton}>
          <Caret /> Edit <code className="prop">type</code>
        </AccordionButton>
        <AccordionPanel>
          <ChoiceList
            data={inputTypeData}
            stateKey="type"
            stateValue={type}
            setConfig={setConfig}
            docLink="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#%3Cinput%3E_types"
          />
        </AccordionPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionButton className={styles.accordionButton}>
          <Caret />{" "}
          {inputmode ? (
            <>
              Edit <code className="prop">inputmode</code>
            </>
          ) : (
            "Override mobile keyboard"
          )}
        </AccordionButton>
        <AccordionPanel>
          <ChoiceList
            data={inputmodeData}
            stateKey="inputmode"
            stateValue={inputmode}
            setConfig={setConfig}
            docLink="https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/inputmode"
          />
        </AccordionPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionButton className={styles.accordionButton}>
          <Caret />{" "}
          {autocomplete ? (
            <>
              Edit <span className="prop">autocomplete</span>
            </>
          ) : (
            <>
              Add <span className="prop">autocomplete</span>
            </>
          )}
        </AccordionButton>
        <AccordionPanel className={styles.autocomplete}>
          <ChoiceList
            data={autocompleteData}
            stateKey="autocomplete"
            stateValue={autocomplete}
            setConfig={setConfig}
            categories={autocompleteCategories}
            docLink="https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete"
          />
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  )
}

export default PropSelector
